import { API_URL } from '../config';
import { safeFetch } from '../utils/safeFetch';

export const NEWS_STATE_CHANGED_EVENT = 'news:changed';

const notifyNewsStateChanged = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(NEWS_STATE_CHANGED_EVENT));
  }
};

export const getNewsList = async () => safeFetch(`${API_URL}/api/news`);
export const getNewsUnreadCount = async () => safeFetch(`${API_URL}/api/news/unread-count`);
export const getLaunchNews = async (appVersion = '') => {
  const query = appVersion ? `?app_version=${encodeURIComponent(appVersion)}` : '';
  return safeFetch(`${API_URL}/api/news/launch${query}`);
};
export const markNewsViewed = async (newsId) => safeFetch(`${API_URL}/api/news/${newsId}/view`, { method: 'POST' });
export const markNewsSkipped = async (newsId) => safeFetch(`${API_URL}/api/news/${newsId}/skip`, { method: 'POST' });
export const markNewsRead = async (newsId) => {
  const result = await safeFetch(`${API_URL}/api/news/${newsId}/read`, { method: 'POST' });
  notifyNewsStateChanged();
  return result;
};
export const markAllNewsRead = async () => {
  const result = await safeFetch(`${API_URL}/api/news/read-all`, { method: 'POST' });
  notifyNewsStateChanged();
  return result;
};
export const getManageNewsList = async () => safeFetch(`${API_URL}/api/news/manage`);
export const createNews = async (payload) => {
  const result = await safeFetch(`${API_URL}/api/news`, { method: 'POST', body: JSON.stringify(payload) });
  notifyNewsStateChanged();
  return result;
};
export const updateNews = async (newsId, payload) => {
  const result = await safeFetch(`${API_URL}/api/news/${newsId}`, { method: 'PUT', body: JSON.stringify(payload) });
  notifyNewsStateChanged();
  return result;
};
export const deleteNews = async (newsId) => {
  const result = await safeFetch(`${API_URL}/api/news/${newsId}`, { method: 'DELETE' });
  notifyNewsStateChanged();
  return result;
};
